require('../../../../node_modules/prismjs/prism.js');
require('../../../../node_modules/prismjs/components/prism-less.js');
require('../../../../node_modules/prismjs/components/prism-sass.js');
require('../../../../node_modules/prismjs/components/prism-bash.js');
